interface MatchInfoPanelProps {
  player1Name: string;
  player2Name: string;
  player1BattleWins: number;
  player2BattleWins: number;
  player1RoundWins: number;
  player2RoundWins: number;
  currentBattle: number;
  currentRound: number;
}

export default function MatchInfoPanel({
  player1Name,
  player2Name,
  player1BattleWins,
  player2BattleWins,
  player1RoundWins,
  player2RoundWins,
  currentBattle,
  currentRound,
}: MatchInfoPanelProps) {
  return (
    <div className="kotch-match-info-panel">
      {/* Player names row */}
      <div className="kotch-match-info-names">
        <span className="kotch-match-info-name">{player1Name}</span>
        <span className="kotch-match-info-name-vs">vs</span>
        <span className="kotch-match-info-name">{player2Name}</span>
      </div>

      <div className="kotch-match-info-divider" />

      {/* Battle score */}
      <div className="kotch-match-info-section">
        <div className="kotch-match-info-label">Battle {currentBattle}</div>
        <div className="kotch-match-info-score">
          <span className="kotch-match-info-val">{player1BattleWins}</span>
          <span className="kotch-match-info-vs">–</span>
          <span className="kotch-match-info-val">{player2BattleWins}</span>
        </div>
      </div>

      <div className="kotch-match-info-divider" />

      {/* Round score */}
      <div className="kotch-match-info-section">
        <div className="kotch-match-info-label">Round {currentRound}</div>
        <div className="kotch-match-info-score">
          <span className="kotch-match-info-val">{player1RoundWins}</span>
          <span className="kotch-match-info-vs">–</span>
          <span className="kotch-match-info-val">{player2RoundWins}</span>
        </div>
      </div>
    </div>
  );
}
